import React from "react";
import { styleClassName } from "../styleHelper";
import BattleInfo from "./BattleInfo";
import GambitTable from "./GambitTable";
import Sprite from "./Sprite";
import { BattleEntryProps } from "./types";

type IBattleStatsTable = Pick<BattleEntryProps["infoProps"], "stats">;

const bannedStats: Record<string, boolean> = {
  hp: true,
  mp: true,
  vitality: true
};
export function BattleStatsTable({ stats }: IBattleStatsTable) {
  const visibleStats = Object.entries(stats).filter(
    ([key]) => !bannedStats[key]
  );
  const className = styleClassName("nes-table is-bordered");
  return (
    <table className={className}>
      <tbody>
        {visibleStats.map(([key, stat]) => (
          <tr key={key}>
            <td>{key}</td>
            <td>{stat.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function BattleEntry(props: BattleEntryProps) {
  const { gambitProps, infoProps, frameProps, index, dispatch } = props;
  const swapItems = (order: number, otherOrder: number) => {
    dispatch({ type: "gambit/swap", payload: { index, order, otherOrder } });
  };
  const toggleItemActive = (id: string) => {
    dispatch({ type: "gambit/activate", payload: { index, id } });
  };
  const changeItem = (id: string) => {
    dispatch({ type: "pick/pickGambit", payload: { index, id } });
  };
  const actions = { swapItems, toggleItemActive, changeItem };
  return (
    <div className="battle-entry">
      <BattleInfo {...infoProps} />
      <div className="battle-entry-entity">
        <BattleStatsTable stats={infoProps.stats} />
        <Sprite {...frameProps} />
      </div>
      <GambitTable {...gambitProps} actions={actions} />
    </div>
  );
}

export default BattleEntry;
